import React from "react";
import { Box, Card, CardContent, Chip, Divider, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function BlogSidebar({ relatedPosts = [], categories = [], popularTags = [] }) {
  return (
    <Stack spacing={2.5}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" sx={{ mb: 1.5 }}>
            Related Posts
          </Typography>
          {relatedPosts.length ? (
            <Stack spacing={1.25}>
              {relatedPosts.map((post) => (
                <Box key={post.id}>
                  <Typography
                    variant="body2"
                    component={RouterLink}
                    to={`/blog/${post.slug}`}
                    sx={{
                      color: "text.primary",
                      textDecoration: "none",
                      fontWeight: 500,
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {post.readingMinutes || 1} min read
                  </Typography>
                </Box>
              ))}
            </Stack>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No related posts found.
            </Typography>
          )}
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" sx={{ mb: 1.5 }}>
            Categories
          </Typography>
          <Stack spacing={1}>
            {categories.map((category) => (
              <Typography
                key={category.slug}
                variant="body2"
                component={RouterLink}
                to={`/blog/category/${category.slug}`}
                sx={{
                  color: "text.primary",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {category.name}
              </Typography>
            ))}
          </Stack>
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" sx={{ mb: 1.5 }}>
            Popular Tags
          </Typography>
          <Divider sx={{ mb: 1.5 }} />
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.8 }}>
            {popularTags.map((tag) => (
              <Chip
                key={tag}
                label={tag}
                size="small"
                component={RouterLink}
                to={`/blog/tag/${encodeURIComponent(tag.toLowerCase())}`}
                clickable
                sx={{ textDecoration: "none" }}
              />
            ))}
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
}

export default BlogSidebar;
